interface Pack extends Record<string, string> {
  "converters.unknownValue": string;
  "productType.spreadBet": string;
  "productType.cfd": string;
  "productType.spotFx": string;
  "tradingInstructionDirection.buy": string;
  "tradingInstructionDirection.sell": string;
  "statementPeriod.daily": string;
  "statementPeriod.monthly": string;
  "tradeSubType.new": string;
  "tradeSubType.roll": string;
  "tradeSubType.fxConversionOpen": string;
  "openingOrClosing.opening": string;
  "openingOrClosing.closing": string;
  "loginForm.usernamePlaceholder": string;
  "loginForm.usernameValidationMessage": string;
  "loginForm.passwordPlaceholder": string;
  "loginForm.passwordValidationMessage": string;
  "grid.bid": string;
  "grid.mid": string;
  "grid.offer": string;
  "grid.cod": string;
  "grid.marketName": string;
  "grid.low": string;
  "grid.high": string;
  "platform.selectLocale": string;
  "clientAccountResources.cashBalance": string;
  "clientAccountResources.openPnL": string;
  "clientAccountResources.marginRequirement": string;
  "clientAccountResources.netOpenPositions": string;
  "clientAccountResources.availableBalance": string;
  "clientAccountResources.netOpenPositionsLimit": string;
  "clientAccountResources.netOpenPositionsAvailable": string;
  "positionsGrid.title": string;
  "positionsGrid.marketName": string;
  "positionsGrid.quantity": string;
  "positionsGrid.currentPrice": string;
  "positionsGrid.netOpenPrice": string;
  "positionsGrid.baseCurrencyOpenPnL": string;
  "positionsGrid.baseCurrencyMargin": string;
  "tradeGrid.title": string;
  "tradeGrid.reference": string;
  "tradeGrid.bookingDate": string;
  "tradeGrid.quantity": string;
  "tradeGrid.marketName": string;
  "tradeGrid.bookingPrice": string;
  "tradeGrid.currentPrice": string;
  "tradeGrid.baseCurrencyProfitAndLoss": string;
  "tradeGrid.baseCurrencyMargin": string;
  "tradeGrid.baseCurrencyConsideration": string;
  "tradeGrid.deliveryCurrencyConsideration": string;
  "tradesByMarketAndValueDateGrid.title": string;
  "tradesByMarketAndValueDateGrid.valueDate": string;
  "tradesByMarketAndValueDateGrid.baseCurrencyConsideration": string;
  "tradesByMarketAndValueDateGrid.deliveryCurrencyConsideration": string;
  "accountSelector.title": string;
  "accountSelector.clientAccountTitle": string;
  "accountSelector.selectTradingAccountButton": string;
  "tradingAccountResources.cashBalance": string;
  "tradingAccountResources.openPnL": string;
  "tradingAccountResources.marginRequirement": string;
  "tradingAccountResources.netOpenPositions": string;
  "tradingAccountResources.netEquity": string;
  "switchAccountButton.text": string;
  "logoutButton.text": string;
  "openPositionsWithTradesByMarketAndValueDateGrids.tradeGridNoPositionSelected": string;
  "openPositionsWithTradesByMarketAndValueDateGrids.tradeGridEmptyText": string;
  "tradeHistoryGrid.reference": string;
  "tradeHistoryGrid.marketName": string;
  "tradeHistoryGrid.quantity": string;
  "tradeHistoryGrid.direction": string;
  "tradeHistoryGrid.baseCurrencyConsideration": string;
  "tradeHistoryGrid.deliveryCurrencyConsideration": string;
  "tradeHistoryGrid.bookingPrice": string;
  "tradeHistoryGrid.bookingTime": string;
  "tradeHistoryGrid.valueDate": string;
  "tradeHistoryGrid.openingOrClosing": string;
  "tradeHistoryGrid.currency": string;
  "tradeHistoryGrid.profitAndLoss": string;
  "tradeHistoryGrid.subType": string;
  "tradeHistory.searching": string;
  "tradeHistory.emptySearchResultsEmptyText": string;
  "tradeHistory.notYetSearchedEmptyText": string;
  "tradeHistory.downloadButton": string;
  "tradeHistorySearchForm.date": string;
  "tradeHistorySearchForm.from": string;
  "tradeHistorySearchForm.to": string;
  "tradeHistorySearchForm.fromAndToDatesRequiredValidationMessage": string;
  "tradeHistorySearchForm.market": string;
  "tradeHistorySearchForm.name": string;
  "tradeHistorySearchForm.direction": string;
  "tradeHistorySearchForm.valueDate": string;
  "tradeHistorySearchForm.search": string;
  "tradeHistorySearchForm.tradeSubType": string;
  "statementsList.date": string;
  "statementsList.period": string;
  "statementsList.fileName": string;
  "statementsList.fileSize": string;
  "statementsList.download": string;
  "statementsSearchFrom.search": string;
  "statementsSearchFrom.date": string;
  "statementsSearchFrom.from": string;
  "statementsSearchFrom.to": string;
  "statementsSearchFrom.period": string;
  "statementsSearchFrom.fromDateToDateAndPeriodRequiredValidationMessage": string;
  "statements.searching": string;
  "statements.emptySearchResultsEmptyText": string;
  "statements.notYetSearchedEmptyText": string;
  "openPositionsGrid.emptyText": string;
  "openTradesGrid.emptyText": string;
}

export enum supportedLocales {
  "en-gb" = "en-gb"
}

export type AllLocales = { [key in supportedLocales]: Pack };

export const strings: AllLocales = {
  "en-gb": {
    "converters.unknownValue": "Unknown",
    "productType.spreadBet": "Spread Bet",
    "productType.cfd": "CFD",
    "productType.spotFx": "Spot FX",
    "tradingInstructionDirection.buy": "Buy",
    "tradingInstructionDirection.sell": "Sell",
    "statementPeriod.daily": "Daily",
    "statementPeriod.monthly": "Monthly",
    "tradeSubType.new": "New",
    "tradeSubType.roll": "Roll",
    "tradeSubType.fxConversionOpen": "FX Conversion",
    "openingOrClosing.opening": "Opening",
    "openingOrClosing.closing": "Closing",
    "platform.selectLocale": "Language",
    "grid.bid": "Bid",
    "grid.mid": "Mid",
    "grid.offer": "Offer",
    "grid.cod": "Change on Day",
    "grid.marketName": "Market",
    "grid.low": "Low",
    "grid.high": "High",
    "loginForm.usernamePlaceholder": "Username",
    "loginForm.usernameValidationMessage": "Please enter your username",
    "loginForm.passwordPlaceholder": "Password",
    "loginForm.passwordValidationMessage": "Please enter your password",
    "clientAccountResources.cashBalance": "Cash",
    "clientAccountResources.marginRequirement": "Margin",
    "clientAccountResources.openPnL": "Open P&L",
    "clientAccountResources.netOpenPositions": "NOP",
    "clientAccountResources.availableBalance": "Available",
    "clientAccountResources.netOpenPositionsLimit": "NOP Limit",
    "clientAccountResources.netOpenPositionsAvailable": "NOP Available",
    "positionsGrid.title": "Daily Market Position Summary",
    "positionsGrid.marketName": "Market",
    "positionsGrid.quantity": "Base Net Position",
    "positionsGrid.currentPrice": "Current Price",
    "positionsGrid.netOpenPrice": "Net Open Price",
    "positionsGrid.baseCurrencyOpenPnL": "Open P&L ({symbol})",
    "positionsGrid.baseCurrencyMargin": "Margin ({symbol})",
    "tradeGrid.title": "Trades",
    "tradeGrid.reference": "Reference",
    "tradeGrid.bookingDate": "Booking Date",
    "tradeGrid.quantity": "Quantity",
    "tradeGrid.marketName": "Market",
    "tradeGrid.bookingPrice": "Booking Price",
    "tradeGrid.currentPrice": "Current Price",
    "tradeGrid.baseCurrencyProfitAndLoss": "Open P&L ({symbol})",
    "tradeGrid.baseCurrencyMargin": "Margin ({symbol})",
    "tradeGrid.baseCurrencyConsideration": "Base Consideration",
    "tradeGrid.deliveryCurrencyConsideration": "Delivery Consideration",
    "tradesByMarketAndValueDateGrid.title": "Trades",
    "tradesByMarketAndValueDateGrid.valueDate": "Value Date",
    "tradesByMarketAndValueDateGrid.baseCurrencyConsideration": "Base Consideration",
    "tradesByMarketAndValueDateGrid.deliveryCurrencyConsideration": "Delivery Consideration",
    "accountSelector.title": "Your Accounts",
    "accountSelector.clientAccountTitle": "Account Summary",
    "accountSelector.selectTradingAccountButton": "Select",
    "tradingAccountResources.cashBalance": "Cash",
    "tradingAccountResources.openPnL": "Open P&L",
    "tradingAccountResources.marginRequirement": "Margin",
    "tradingAccountResources.netOpenPositions": "NOP",
    "tradingAccountResources.netEquity": "Net Equity",
    "switchAccountButton.text": "Switch Account",
    "logoutButton.text": "Logout",
    "openPositionsWithTradesByMarketAndValueDateGrids.tradeGridNoPositionSelected": "Select a position to view its trades",
    "openPositionsWithTradesByMarketAndValueDateGrids.tradeGridEmptyText": "No open trades",
    "tradeHistoryGrid.reference": "Reference",
    "tradeHistoryGrid.marketName": "Market",
    "tradeHistoryGrid.quantity": "Quantity",
    "tradeHistoryGrid.direction": "Direction",
    "tradeHistoryGrid.baseCurrencyConsideration": "Base Consideration",
    "tradeHistoryGrid.deliveryCurrencyConsideration": "Delivery Consideration",
    "tradeHistoryGrid.bookingPrice": "Booking Price",
    "tradeHistoryGrid.bookingTime": "Booking Date",
    "tradeHistoryGrid.valueDate": "Value Date",
    "tradeHistoryGrid.openingOrClosing": "Opening/Closing",
    "tradeHistoryGrid.currency": "Currency",
    "tradeHistoryGrid.profitAndLoss": "P&L",
    "tradeHistoryGrid.subType": "Sub Type",
    "tradeHistory.searching": "Searching…",
    "tradeHistory.emptySearchResultsEmptyText": "No trades found that match the given search critera",
    "tradeHistory.notYetSearchedEmptyText": "Use the search to find trades",
    "tradeHistory.downloadButton": "Download",
    "tradeHistorySearchForm.date": "Date",
    "tradeHistorySearchForm.from": "From",
    "tradeHistorySearchForm.fromAndToDatesRequiredValidationMessage": "From and to dates are required",
    "tradeHistorySearchForm.to": "To",
    "tradeHistorySearchForm.market": "Market",
    "tradeHistorySearchForm.name": "Name",
    "tradeHistorySearchForm.direction": "Direction",
    "tradeHistorySearchForm.valueDate": "Value Date",
    "tradeHistorySearchForm.search": "Search",
    "tradeHistorySearchForm.tradeSubType": "Sub Type",
    "statementsList.date": "Date",
    "statementsList.period": "Period",
    "statementsList.fileName": "Filename",
    "statementsList.fileSize": "Size",
    "statementsList.download": "Download",
    "statementsSearchFrom.search": "Search",
    "statementsSearchFrom.date": "Date",
    "statementsSearchFrom.from": "From",
    "statementsSearchFrom.to": "To",
    "statementsSearchFrom.period": "Period",
    "statementsSearchFrom.fromDateToDateAndPeriodRequiredValidationMessage": "From and to dates, and period are required",
    "statements.searching": "Searching…",
    "statements.emptySearchResultsEmptyText": "No statements found for the given search critera",
    "statements.notYetSearchedEmptyText": "Use the search to view your statements",
    "openPositionsGrid.emptyText": "No open positions",
    "openTradesGrid.emptyText": "No open trades"
  }
};
